import React from 'react';
import { Youtube, Instagram, ExternalLink, Facebook, Send, Twitter, MessageCircle } from 'lucide-react';
import { getWaChannelUrl } from '../lib/whatsappChannel';

const Media = () => {
  const socialLinks = [
    { name: "Instagram", url: "https://instagram.com/thubaproject/", icon: Instagram, color: "text-pink-500", border: "border-pink-500/20 hover:bg-pink-500/10" },
    { name: "Facebook", url: "https://facebook.com/thubaproject", icon: Facebook, color: "text-blue-500", border: "border-blue-500/20 hover:bg-blue-500/10" },
    { name: "Youtube", url: "https://www.youtube.com/@ThubaProject/streams", icon: Youtube, color: "text-red-500", border: "border-red-500/20 hover:bg-red-500/10" },
    { name: "Tiktok", url: "https://tiktok.com/@thuba.project", icon: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" /></svg>, color: "text-white", border: "border-white/20 hover:bg-white/10" },
    { name: "Threads", url: "https://threads.com/@thubaproject", icon: () => <span className="font-bold text-lg">@</span>, color: "text-white", border: "border-white/20 hover:bg-white/10" },
    { name: "Telegram", url: "https://t.me/thubaproject", icon: Send, color: "text-blue-400", border: "border-blue-400/20 hover:bg-blue-400/10" },
    { name: "X (Twitter)", url: "https://x.com/thubaproject", icon: Twitter, color: "text-white", border: "border-white/20 hover:bg-white/10" },
    { name: "WA Channel", url: getWaChannelUrl(), icon: MessageCircle, color: "text-green-500", border: "border-green-500/20 hover:bg-green-500/10" },
  ];

  return (
    <div className="pt-24 min-h-screen bg-[#081c1a] animate-fade-in-up">
      <div className="container mx-auto px-6 py-12">
        <h1 className="text-5xl font-serif font-bold text-white mb-6 text-center">Thuba <span className="text-gold">Media</span></h1>
        <p className="text-center text-muted-foreground max-w-2xl mx-auto mb-16">
          Ikuti terus update kajian, dokumentasi kegiatan, dan konten inspiratif kami melalui kanal resmi Thuba Project.
        </p>

        {/* All Social Links Section */}
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`flex flex-col items-center justify-center gap-4 p-8 rounded-2xl border transition-all duration-300 group hover:-translate-y-2 ${social.border} bg-white/5 backdrop-blur-sm`}
              >
                <div className={`p-4 rounded-full bg-white/5 group-hover:scale-110 transition-transform duration-300 ${social.color}`}>
                  <social.icon size={32} />
                </div>
                <div className="text-center">
                  <span className="text-white font-bold text-lg block mb-1">{social.name}</span>
                  <span className="text-xs text-muted-foreground group-hover:text-gold transition-colors flex items-center justify-center gap-1">
                    Kunjungi <ExternalLink size={10} />
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Media;
